import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { defaultShouldDehydrateQuery, QueryClient } from '@tanstack/react-query';
import type { PersistQueryClientProviderProps } from '@tanstack/react-query-persist-client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      gcTime: Infinity,
      networkMode: 'offlineFirst',
      retry: 0,
    },
  },
});

const persister = createAsyncStoragePersister({
  storage: window.localStorage,
});

const persistentQueries = ['CURRENT_USER'];

export const persistOptions: PersistQueryClientProviderProps['persistOptions'] = {
  persister,
  maxAge: Infinity,
  dehydrateOptions: {
    shouldDehydrateQuery: (query) =>
      defaultShouldDehydrateQuery(query) && persistentQueries.some((key) => query.queryKey.includes(key)),
  },
};
